export const GOOGLE_CAPTCHA_API_KEY = '6LduOAoaAAAAAJ-Aa84QpXxKf8oCEdv6XOE9M5-2';
